import { formatCounter } from "antd/es/statistic/utils"
import { formatAmount, truncateToTwoDecimals } from "../../components/dms_common/DmsUtils"
import { getPrimarySummary } from "../../services/manageOrderService"
import { GenericSummaryCardItemObject } from "../../components/dms_common/GenericSummaryCard"

export const managePrimaryOrderColumnsMetaData = (showSiteId: boolean) => {


  return {

    columns: [
      {
        headerName: "Order No. & date",
        headerParts: { top: "Order No.", bottom: "& date" },
        mappedValue: "orderNumber,creationTime",
        width: 190,
        headerAlign: "left",
        align: "left",
        truncateText: true,
      },
      {
        headerName: "Distributor Name & Code",
        headerParts: { top: "Distributor Name ", bottom: "& Code" },
  
        mappedValue: "outletName, outletCode",
        width: 200,
        headerAlign: "left",
        align: "left",
        truncateText: true,
      },

      ...(showSiteId
        ? [
            {
              headerName: "Site",
              mappedValue: "siteId",
              width: 100,
              headerAlign: "left",
              align: "left",
              truncateText: true,
            },
          ]
        : []),
     
    { headerName: "Quantity", mappedValue: "totalCaseQuantity, totalPieceQuantity, totalOtherUnitQuantity", width: 120, headerAlign: "left", align: "left", 
      type: "viewprimaryorderconfigs", },
      {
        headerName: "Amount",
        mappedValue: "netAmount",
        width: 120,
        headerAlign: "left",
        align: "left",
      },
      {
        headerName: "Order Source",
        headerParts: { top: "Order", bottom: "source" },
        mappedValue: "source",
        width: 120,
        headerAlign: "left",
        align: "left",
        truncateText: true,
      },
      {
        headerName: "Status",
        mappedValue: "status",
        width: 150,
        headerAlign: "left",
        align: "left",
      },
    ],
    Actions: ["view", "download"],
  }
}


export const managePrimaryOrderColumnsMetaDataV2 = (showSiteId: boolean) => {

  return {

    columns: [
      {
        headerName: "Order No. & date",
        headerParts: { top: "Order No.", bottom: "& Date" },
        mappedValue: "orderNumber,creationTime",
        width: 190,
        headerAlign: "left",
        align: "left",
        truncateText: true,
        sortKey: "creationTime",
        sortType: "date"
      },
      {
        headerName: "Distributor Name & Code",
        headerParts: { top: "Distributor Name ", bottom: "& Code" },
  
        mappedValue: "outletName, outletCode",
        width: 170,
        headerAlign: "left",
        align: "left",
        truncateText: true,
      },

      ...(showSiteId
        ? [
            {
              headerName: "Site",
              mappedValue: "siteId",
              width: 100,
              headerAlign: "left",
              align: "left",
              truncateText: true,
            },
          ]
        : []),
     
    { headerName: "Quantity", 
      headerParts: { top: "Ordered ", bottom: "Quantity" },
      mappedValue: "totalCaseQuantity, totalPieceQuantity, totalOtherUnitQuantity", 
      width: 120, 
      headerAlign: "left", 
      align: "left", 
      type: "viewprimaryorderconfigs",
      sortKey: "normalizedQuantity",
      sortType: "number"
    },
    { headerName: "TotalQuantity", 
      headerParts: { top: "Total ", bottom: "Qty" },
      mappedValue: "totalConvertedCases", 
      width: 100, 
      headerAlign: "center", 
      align: "center", 
    },
      {
        headerName: "Amount",
        mappedValue: "netAmount",
        width: 120,
        headerAlign: "left",
        align: "left",

        sortKey: "netAmount",
        sortType: "number"
      },
      {
        headerName: "Order Source",
        headerParts: { top: "Order", bottom: "source" },
        mappedValue: "source",
        width: 120,
        headerAlign: "left",
        align: "left",
        truncateText: true,
      },
      {
        headerName: "Status",
        mappedValue: "status",
        width: 150,
        headerAlign: "left",
        align: "left",
      },
    ],
    Actions: ["view", "download"],
  }
}

export const generatePrimarySummary = async (startDate: string, endDate: string) => {
  const data = await getPrimarySummary(startDate, endDate);
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}")
  const currencySymbol = ConfigDictionary.currency;

  const summary ={
    ordersCountDMS: String(data.totalOrdersSubtype.dms ?? 0),
    ordersCountARS: String(data.totalOrdersSubtype.ars ?? 0),
    ordersAmountDMS: formatAmount(data.totalAmountSubtype.dms ?? 0, currencySymbol),
    ordersAmountARS: formatAmount(data.totalAmountSubtype.ars ?? 0, currencySymbol),
    invoicesCountDMS: String(data.totalInvoiceCountSubtype.dms ?? 0),
    invoicesCountARS: String(data.totalInvoiceCountSubtype.ars ?? 0),
    invoicesAmountDMS: formatAmount(data.totalInvoiceAmountSubtype.dms ?? 0, currencySymbol),
    invoicesAmountARS: formatAmount(data.totalInvoiceAmountSubtype.ars ?? 0, currencySymbol),
    openInvoiceCountDMS: String(data.openInvoiceCountSubtype.dms ?? 0),
    openInvoiceCountARS: String(data.openInvoiceCountSubtype.ars ?? 0),
    openInvoiceAmountDMS: formatAmount(data.openInvoiceAmountSubtype.dms ?? 0, currencySymbol),
    openInvoiceAmountARS: formatAmount(data.openInvoiceAmountSubtype.ars ?? 0, currencySymbol),

    openInvoiceOrderCountDMS: String(data.openInvoiceOrderCountSubtype.dms ?? 0),
    openInvoiceOrderCountARS: String(data.openInvoiceOrderCountSubtype.ars ?? 0),
    openInvoiceOrderAmountDMS: formatAmount(data.openInvoiceOrderAmountSubtype.dms ?? 0, currencySymbol),
    openInvoiceOrderAmountARS: formatAmount(data.openInvoiceOrderAmountSubtype.ars ?? 0, currencySymbol),

    totalOpenInvoiceCount: String(data.openInvoiceCount ?? 0),
    totalOpenInvoiceAmount: formatAmount(data.openInvoiceAmount ?? 0, currencySymbol),
    acceptedInvoiceCount: String(data.acceptedInvoiceCount ?? 0),
    acceptedInvoiceAmount: formatAmount(data.acceptedInvoiceAmount ?? 0, currencySymbol),
    rejectedInvoiceCount: String(data.rejectedInvoiceCount ?? 0),
    rejectedInvoiceAmount: formatAmount(data.rejectedInvoiceAmount ?? 0, currencySymbol),
    partiallyAcceptedInvoiceCount: String(data.partiallyInvoiceCount ?? 0),
    partiallyAcceptedInvoiceAmount: formatAmount(data.partiallyInvoiceAmount ?? 0, currencySymbol),
  }

  return summary;
}


export const initialSummaryValuesGRN:GenericSummaryCardItemObject[] = [
  {
    itemLabel: 'Open GRN',
    itemValue1: "0",
    itemValue2: "0",
    svgIcon: 'invoiceDisclaimerIcon',
    itemStyles: {
      itemValue1: {
        fontWeight: "bold"
      },
      itemValue2: {
        color: "#D38E48",
        backgroundColor: "#FFF3E0"
      },
      svgIcon: {
        color: "#D38E48"
      }
    },
  },
  {
    itemLabel: 'Accepted GRN',
    itemValue1: "0",
    itemValue2: "0",
    svgIcon: 'invoicedOrdersSVG',
    itemStyles: {
      itemValue1: {
        fontWeight: "bold"
      },
      itemValue2: {
        color: "#5A865A",
        backgroundColor: "#EAFFEA"
      },
      svgIcon: {
        color: "#5A865A"
      }
    },
  },
    {
    itemLabel: 'Partially Accepted GRN',
    itemValue1: "0",
    itemValue2: "0",
    svgIcon: 'pendingOrdersSVG',
    itemStyles: {
      itemValue1: {
        fontWeight: "bold"
      },
      itemValue2: { 
        color: "#1E88E5",
        backgroundColor: "#E3F2FD"
      },
      svgIcon: { color: '#1E88E5', width: '1em' },
    },
  },
  {
    itemLabel: 'Rejected GRN',
    itemValue1: "0",
    itemValue2: "0",
    svgIcon: 'rejectedSVG',
    itemStyles: {
      itemValue1: {
        fontWeight: "bold"
      },
      itemValue2: {
        color: "#B54747",
        backgroundColor: "#FFEBEE"
      },
      svgIcon: {
        width: '1em',
        color: "#B54747"
      }
    },
  },
]

export const initialSummaryValuesPrimary:GenericSummaryCardItemObject[] =  [
  {
    itemLabel: 'Total Orders',
    itemValue1: "0",
    itemValue2: "0",
    svgIcon: 'pendingOrdersSVG',
    itemStyles: {
      itemValue1: {
        fontWeight: "bold"
      },
      itemValue2: { 
        color: "#1E88E5",
        backgroundColor: "#E3F2FD"
      },
      svgIcon: { color: '#1E88E5', width: '1em' },
    },
  },
  {
    itemLabel: 'Total Invoices',
    itemValue1: "0",
    itemValue2: "0",
    svgIcon: 'invoicedOrdersSVG',
    itemStyles: {
      itemValue1: {
        fontWeight: "bold"
      },
      itemValue2: {
        color: "#5A865A",
        backgroundColor: "#EAFFEA"
      },
      svgIcon: {
        color: "#5A865A"
      }
    },
  },
  {
    itemLabel: 'Open GRN',
    itemValue1: "0",
    itemValue2: "0",
    svgIcon: 'invoiceDisclaimerIcon',
    itemStyles: {
      itemValue1: {
        fontWeight: "bold"
      },
      itemValue2: {
        color: "#CC8034",
        backgroundColor: "#FFFBE7"
      },
      svgIcon: {
        color: "#CC8034"
      }
    },
  }
]
